import React from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  Grow,
} from "@mui/material";
import {
  ArrowUpward,
  ArrowDownward,
} from "@mui/icons-material";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: number;
  color: string;
  delay?: number;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  trend,
  color,
  delay = 0,
}) => {
  return (
    <Grow in timeout={600 + delay}>
      <Card
        sx={{
          height: "100%",
          bgcolor: "background.paper",
          borderRadius: "8px",
          border: "1px solid",
          borderColor: "divider",
          transition: "all 0.3s",
          "&:hover": {
            transform: "translateY(-4px)",
            borderColor: `${color}30`,
            boxShadow: `0 4px 12px ${color}15`,
          },
        }}
      >
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Box
              sx={{
                p: 1.5,
                borderRadius: 1,
                bgcolor: `${color}20`,
                display: "inline-flex",
              }}
            >
              <Box sx={{ fontSize: 28, color }}>{icon}</Box>
            </Box>
            {trend !== undefined && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                {trend >= 0 ? (
                  <ArrowUpward sx={{ fontSize: 16, color: "#00ff88" }} />
                ) : (
                  <ArrowDownward sx={{ fontSize: 16, color: "#ff3366" }} />
                )}
                <Typography
                  variant="body2"
                  sx={{
                    color: trend >= 0 ? "#00ff88" : "#ff3366",
                    fontWeight: 600,
                  }}
                >
                  {Math.abs(trend)}%
                </Typography>
              </Box>
            )}
          </Box>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
            {value}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {title}
          </Typography>
        </CardContent>
      </Card>
    </Grow>
  );
};

export default StatCard;